import { render } from "./nested.vue?vue&type=template&id=e4c4263c&scoped=true"
import script from "./nested.vue?vue&type=script&lang=js"
export * from "./nested.vue?vue&type=script&lang=js"

import "./nested.vue?vue&type=style&index=0&id=e4c4263c&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4c4263c"]])

export default __exports__